// extracted by mini-css-extract-plugin
export var header = "_i8-0";